export default {
  SET_MARKET_CAPITALIZATION(state, payload) {
    state.asOfDate = payload.marketCapAsOfDate;
    state.factSetAsOfDate = payload.factSetAsOfDate;
    state.marketCapLarge = payload.marketCapLarge;
    state.marketCapMedium = payload.marketCapMedium;
    state.marketCapSmall = payload.marketCapSmall;
    state.weightedAvg = payload.weightedAvg;
  }
};
